<template>
  <section class="eventHistory">
    <event-history-table
      ref="table"
      :items="tableItems"
      :headers="computedHeaders"
      :selected-day="selectedDay"
      :display-image="displayImage"
    >
      <template #header>
        <history-select
          :min-date="minMaxItemsDate.minDate"
          :max-date="minMaxItemsDate.maxDate"
          is-image
          @day="handleSelectDay"
          @dates="handleSelectDates"
          @image="handleDisplayImage"
        />
      </template>
    </event-history-table>
  </section>
</template>

<script>
import EventHistoryTable from './EventHistoryTable.vue';
import { MimeTypes } from '@/globals/enums';
import HistorySelect from '@/components/inputs/HistorySelect.vue';
import dayjs from 'dayjs';
import { mapState } from 'vuex';

export default {
  name: 'EventHistory',
  components: {
    EventHistoryTable,
    HistorySelect,
  },
  data: () => ({
    mimeTypes: MimeTypes,
    displayImage: true,
    hasDate: false,
    selectedDates: [],
    headers: [
      {
        text: '日付',
        align: 'start',
        sortable: false,
        value: 'date',
        width: '90',
      },
      {
        text: '時刻',
        align: 'start',
        sortable: false,
        value: 'time',
        width: '90',
      },
      {
        text: 'カメラ名称',
        value: 'cameraName',
        sortable: false,
        align: 'start',
        width: '110',
      },
      {
        align: 'start',
        sortable: false,
        value: 'thumbnailUrl',
        width: '140',
      },
      {
        text: 'イベント履歴詳細',
        align: 'start',
        sortable: false,
        value: 'historyName',
        width: '160',
      },
    ],
    selectedItems: [],
    selectedDay: null,
    clipToolsOpen: false,
  }),

  computed: {
    ...mapState({
      items: (state) => state.log.logByCategory,
    }),
    computedHeaders() {
      return this.headers.map((item) => ({
        ...item,
        align:
          item.value === 'thumbnailUrl'
            ? this.displayImage
              ? 'start'
              : ' d-none'
            : item.align,
      }));
    },
    tableItems() {
      return this.items[1]
        ? this.items[1].map((item, index) => {
            return {
              id: `index-${index}`,
              date: dayjs(item.date.split(',')[0]).format('YYYY/MM/DD'),
              time: dayjs(item.date.split(',')[0]).format('HH:mm:ss'),
              thumbnailUrl: item.thumbnailUrl,
              historyName: item.historyName,
              cameraName: item.cameraName,
            };
          })
        : [];
    },
    minMaxItemsDate() {
      if (this.tableItems.length === 0) {
        return {
          minDate: null,
          maxDate: null,
        };
      }
      const minDate = dayjs(this.tableItems[0].date).toDate();
      const maxDate = dayjs(
        this.tableItems[this.tableItems.length - 1].date
      ).toDate();
      return { minDate, maxDate };
    },
  },
  methods: {
    handleDisplayImage(displayImage) {
      this.displayImage = displayImage;
    },
    handleSelectDay(day) {
      this.selectedDay = day;
    },
    handleSelectDates(dates) {
      this.selectedDates = dates;
      this.handleSearch();
    },
    handleSearch() {
      const { table } = this.$refs;
      const filterParams = {};
      if (this.selectedDates.length > 0) {
        filterParams.startDate = this.selectedDates[0];
        filterParams.endDate = this.selectedDates[1];
      }
      table.handleSearch(table.$refs, filterParams);
    },
  },
};
</script>

<style lang="scss">
.eventHistory {
  display: flex;
  flex-direction: column;
}
</style>
